import {
  FlaskConical,
  LayoutTemplate,
  Megaphone,
  TextCursorInput,
} from "lucide-react";

/** Make modes — the four things Nara can build (spec §3.3). Local to Make. */
export type MakeMode = "landing" | "ab" | "campaign" | "form";

export const MAKE_MODES: { value: MakeMode; label: string; icon: typeof FlaskConical }[] = [
  { value: "landing", label: "Landing page", icon: LayoutTemplate },
  { value: "ab", label: "A/B test", icon: FlaskConical },
  { value: "campaign", label: "Campaign", icon: Megaphone },
  { value: "form", label: "Form", icon: TextCursorInput },
];

/** Pick the most likely mode from an incoming deep-link prompt. */
export function inferMode(prompt: string): MakeMode {
  const p = prompt.toLowerCase();
  if (p.includes("a/b") || p.includes("variant") || (p.includes("test") && !p.includes("testimonial")))
    return "ab";
  if (p.includes("form") || p.includes("waitlist")) return "form";
  if (p.includes("campaign")) return "campaign";
  return "landing";
}

export const MODE_PLACEHOLDER: Record<MakeMode, string> = {
  landing: "Tell Nara what to make…",
  ab: "Tell Nara what to test…",
  campaign: "Tell Nara what to launch…",
  form: "Tell Nara what to capture…",
};
